import { Box, HStack } from "@chakra-ui/react";
import * as React from "react";

export type StatusPillTone =
  | "green"
  | "blue"
  | "amber"
  | "red"
  | "gray"
  | "yellow";

interface StatusPillProps {
  tone: StatusPillTone;
  children: React.ReactNode;
}

const DOT_COLORS: Record<StatusPillTone, string> = {
  green: "pill.green.dot",
  blue: "pill.blue.text",
  amber: "brandOrange",
  red: "red.500",
  gray: "pill.gray.text",
  yellow: "pill.yellow.dot",
};

export function StatusPill({ tone, children }: StatusPillProps) {
  return (
    <HStack
      background={`pill.${tone}.bg` as any}
      borderRadius="full"
      boxShadow={`pill.${tone}` as any}
      color={`pill.${tone}.text` as any}
      display="inline-flex"
      gap="1.5"
      height="6"
      paddingX="2"
      textStyle="pill"
      whiteSpace="nowrap"
    >
      <Box
        background={DOT_COLORS[tone] as any}
        borderRadius="full"
        flexShrink="0"
        height="1.5"
        width="1.5"
      />
      {children}
    </HStack>
  );
}
